import { render } from "./AllTicketsDoing.vue?vue&type=template&id=9ed3897c&scoped=true&ts=true"
import script from "./AllTicketsDoing.vue?vue&type=script&lang=ts"
export * from "./AllTicketsDoing.vue?vue&type=script&lang=ts"

import "./AllTicketsDoing.vue?vue&type=style&index=0&id=9ed3897c&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ed3897c"]])

export default __exports__